import React, {useCallback, useEffect, useState} from 'react';
import {IFarmer} from 'constants/interfaces';
import {
  Box,
  Card,
  Checkbox,
  CircularProgress,
  InputBase,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Typography,
} from '@material-ui/core';
import {apiSearchFarmers} from 'constants/Api';
import SearchIcon from '@material-ui/icons/Search';
import {NavigationService} from 'services/index';
import {reduxToggleSidePanel} from 'appredux/actions';

export default function AddCustomer() {
  const [farmerSearchTerm, setFarmerSearchTerm] = useState<string>('');
  const [isLoadingFarmers, setIsLoadingFarmers] = useState<boolean>(false);
  const [farmers, setFarmers] = useState<IFarmer[]>([]);

  const loadFarmers = useCallback(() => {
    setIsLoadingFarmers(true);
    apiSearchFarmers(farmerSearchTerm)
      .then(setFarmers)
      .catch((error) => {
        alert('Error loading farmers. Please try again later');
        console.error(error);
      })
      .then(() => setIsLoadingFarmers(false));
  }, [farmerSearchTerm]);

  useEffect(() => {
    if (farmerSearchTerm.length) {
      setIsLoadingFarmers(true);
      const timeout = setTimeout(loadFarmers, 1000);
      return () => clearTimeout(timeout);
    }
  }, [farmerSearchTerm, loadFarmers]);

  const handleFarmerSelect = (farmer: IFarmer) => {
    reduxToggleSidePanel(false, null);
    NavigationService.navigate(`/customers/${farmer.userId}`);
  };

  return (
    <Box className="add-quote">
      <FarmerSearch
        onSearchTermChange={setFarmerSearchTerm}
        isLoading={isLoadingFarmers}
      />
      {!!farmerSearchTerm.length && !isLoadingFarmers && (
        <FarmerList
          farmers={farmers}
          isSelected={false}
          onFarmerSelect={handleFarmerSelect}
          onFarmerDeselect={() => null}
        />
      )}
    </Box>
  );
}

function FarmerSearch(props: {
  onSearchTermChange: (searchTerm: string) => any;
  isLoading?: boolean;
}) {
  return (
    <Paper
      component="form"
      className="farmer-search-container"
      variant="outlined"
    >
      <InputBase
        className="farmer-search-input"
        placeholder="Search farmers"
        onChange={(event) => props.onSearchTermChange(event.target.value)}
      />
      {props.isLoading ? (
        <CircularProgress size={20} thickness={6} className="search-icon" />
      ) : (
        <SearchIcon className="search-icon" />
      )}
    </Paper>
  );
}

function FarmerList(props: {
  farmers: IFarmer[];
  isSelected?: boolean;
  onFarmerSelect: (farmer: IFarmer) => any;
  onFarmerDeselect: (farmer: IFarmer) => any;
}) {
  if (!props.farmers?.length)
    return (
      <Card variant="outlined" className="farmer-list">
        <Box p={1}>
          <Typography variant="caption">No search results</Typography>
        </Box>
      </Card>
    );
  return (
    <Card variant="outlined" className="farmer-list">
      <List dense>
        {props.farmers.map((farmer) => (
          <ListItem
            button
            key={farmer.id}
            onClick={() => props.onFarmerSelect(farmer)}
          >
            <ListItemText
              primary={farmer.name + ' ' + farmer.surname}
              secondary={farmer.address}
              // secondary={farmer.farm?.name}
            />
            <ListItemSecondaryAction>
              <Checkbox
                edge="end"
                onChange={() =>
                  props.isSelected
                    ? props.onFarmerDeselect(farmer)
                    : props.onFarmerSelect(farmer)
                }
                checked={props.isSelected}
                color="primary"
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Card>
  );
}
